<template>
  <div class="box">
    <div class="left">
      <ul>
        <li
          v-for="(item, index) in navList"
          :key="item.id"
          style="cursor: pointer"
          class="left-b-l"
          :class="{ org:  item.id==activeNav.id }"
          @click="selectNav(item)"
        >
          <div class="nav">
            <aside v-if="item.num">{{ item.num }}</aside>
            <img :src="item.avatar" alt="" />
          </div>
          <div class="nav1">
            <section>
              <b>{{ item.name }}</b>
              <span>{{ item.time }}</span>
            </section>
            <p>{{ item.content }}</p>
          </div>
        </li>
      </ul>
    </div>
   
    <div class="right" v-if="activeNav">
      <ul class="cont-active">
        <li class="right-t">
          <p>{{ activeNav.name }}</p>
        </li>
        <li class="right-b">
          <!--<p>12-06 08:18</p>-->
          <div class="txt"  v-for="(item, idx) in todolist"  :key="item.id">
            <img :src="activeNav.avatar" alt="" />
            <span>
              <p v-html="item.title"></p>
              <b v-html="item.content"></b>
              <button v-if="item.btn">
                <p>点击查看</p>
              </button>
            </span>
          </div>
          <!--<div class="txt" v-if="item.num">
            <img :src="item.img" alt="" />
            <span>
              <p v-html="item.txtp"></p>
              <b v-html="item.txtb"></b>
              <button v-if="item.btn">
                <p>点击查看</p>
              </button>
            </span>
          </div>-->
        </li>
      </ul>
    </div>

    <div class="right" v-else>

   </div>
  </div>
</template>
<script>
import { chatList,messagelist,syatemMessage} from "@/api/chat/index";

export default {
  data() {
    return {
     
   
      systemProp:{
          records:[],
          total:0,
          page:1,
          limit:10
        },  


      platformProp:{
        records:[],
        total:0,
        page:1,
        limit:10
      },
      approvalProp:{
          records:[],
          total:0,
          page:1,
          limit:10
        },  

      activeNav: {
          id: "",
        },  
      navList: [
       
        {
          id: 1,
          type:1,
          avatar: require("@/assets/chat-img/plaimg2.png"),
          name: "系统通知",
          time: "",
          num: 0,
          content: "",
        },
        {
          id: 2,
          type:2,
          avatar: require("@/assets/chat-img/plaimg1.png"),
          name: "平台信息",
          time: "",
          num: 0,
          content: "",
        },
       /* {
          id: 3,
          avatar: require("@/assets/chat-img/plaimg3.png"),
          name: "邀请面试",
          time: "1997年12月10日",
          num: 0,
          content: "[凤凰花开]已接受面试",
        },*/
        {
          id: 3,
          type:3,
          avatar: require("@/assets/chat-img/plaimg4.png"),
          name: "审批汇报",
          time: "",
          num: 0,
          content: "",
        },
      ],
      todolist: [
       
      ],
    };
  },
  mounted(){
    this.fetchSysMsgList();
    this.fetchPlatformMsgList();
    this.fetchApprovalMsgList();
  },
  methods: {
    selectNav(item) {
      this.activeNav=item;
      if(item.type==1){
        this.todolist=this.systemProp.records;
      }
      if(item.type==2){
        this.todolist=this.platformProp.records;
      }
      if(item.type==3){
        this.todolist=this.approvalProp.records;
      }
      
    },

    //1系统消息，2平台消息，3审批消息
    fetchSysMsgList(){
      var that = this;
      var params={
        "type":1,
        "page":that.systemProp.page,
        "limit":that.systemProp.limit
      }
      syatemMessage(params).then((response) => {
          that.systemProp.records=response.data.data;
          that.systemProp.total=response.data.total;

          that.navList[0].time= that.systemProp.records[0]?that.systemProp.records[0].updated_at:'';
          that.navList[0].content= that.systemProp.records[0]?that.systemProp.records[0].title:''
      });
    },

    fetchPlatformMsgList(){
      var that = this;
      var params={
        "type":2,
        "page":that.platformProp.page,
        "limit":that.platformProp.limit
      }
      syatemMessage(params).then((response) => {
          that.platformProp.records=response.data.data;
          that.platformProp.total=response.data.total;
          that.navList[1].time= that.platformProp.records[0]?that.platformProp.records[0].updated_at:'';
          that.navList[1].content= that.platformProp.records[0]?that.platformProp.records[0].title:'';
      });
    },



    fetchApprovalMsgList(){
      var that = this;
      var params={
        "type":3,
        "page":that.approvalProp.page,
        "limit":that.approvalProp.limit
      }
      syatemMessage(params).then((response) => {
          that.approvalProp.records=response.data.data;
          that.approvalProp.total=response.data.total;
          that.navList[2].time=that.approvalProp.records[0]? that.approvalProp.records[0].updated_at:'';
          that.navList[2].content= that.approvalProp.records[0]?that.approvalProp.records[0].title:'';
      });
    },


  },
};
</script>
<style lang="scss" scoped>
.box {
  height: 648px;
  display: flex;
}

.left {
  background-color: #ffffff;
  width: 316px;
}
.right {
  width: 884px;
  background-color: #fbfbfb;
}
.org {
  background-color: #eef2ff;
}

.left ul li {
  height: 77px;
  list-style-type: none;
  // margin-right: 0px;
  // text-align: center;
}
.left ul {
  height: 648px;
  overflow: scroll;
}

.left ul::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 1px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.left-b-l {
  display: flex;
  width: 316px;
  height: 77px;
  box-sizing: border-box;
  padding: 5px 12px 5px 0;
}

.left-b-l .nav {
  width: 67px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.left-b-l img {
  width: 43px;
  height: 43px;
  border-radius: 50%;
}
.left-b-l .nav1 {
  width: 249px;
  // background-color: blue;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
}

.left-b-l .nav1 section {
  width: 249px;
  padding-right: 11px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  display: flex;
  justify-content: space-between;
}

.left-b-l .nav1 section b {
  display: block;
}

.left-b-l .nav1 section span {
  display: block;
  font-size: 11px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
}

.left-b-l .nav1 p {
  font-size: 11px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
}
.right .right-t {
  width: 884px;
  height: 72px;
  background: #f3f3f3;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.16);
  display: flex;
  justify-content: center;
  align-items: center;
}
.right .right-t p {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
}
.right .right-b {
  height: 550px;
  padding-left: 22px;
  padding-top: 20px;
  overflow: auto;
  max-height: 550px;
}
.cont {
  display: none;
}
.cont-active {
  display: block;
}
aside {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 12px;
  right: 0px;
  color: #fff;
  background-color: #ff4e4e;
  border-radius: 10px;
  line-height: 20px;
  font-size: 12px;
  text-align: center;
}
.right .right-b > p {
  display: flex;
  height: 56px;
  margin-bottom: 10px;
  color: #999999;
  font-size: 11px;
  justify-content: center;
  align-items: flex-end;
}
.right .right-b .txt {
  display: flex;
  margin-bottom: 38px;
}
.right .right-b .txt img {
  width: 43px;
  height: 43px;
  border-radius: 50%;
}
.right .right-b .txt span {
  display: flex;
  flex-direction: column;
  width: 280px;
  background-color: #eef2ff;
  padding: 19px;
  margin-left: 7px;
}
.right .right-b .txt span > p {
  height: 20px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  display: inline-block;
  white-space: nowrap; 
  width: 100%; 
  overflow: hidden;
  text-overflow:ellipsis;
}
.right .right-b .txt span > b {
  display: block;
  // height: 25px;
  line-height: 25px;
  margin-top: 10px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
}
.right .right-b .txt span > button {
  margin-top: 29px;
  width: 66px;
  height: 27px;
  background: #4c71db;
  border: 0;
  border-radius: 3px;
}
.right .right-b .txt span > button > p {
  color: #fff;
  font-size: 11px;
  font-family: Source Han Sans CN;
  font-weight: 400;
}
</style>